import { spiColors } from '@src/utils/kpi/tools';

import { SESSION_WIDGET_CONFIG, SESSIONS_METRICS, SPI_METRIC } from '@utils/kpi/spi';
import { IMPROVEMENT_OPPORTUNITY_METRICS } from '@src/utils/kpi';

export const SPI_QUERY_METRICS = [
  SPI_METRIC,
  ...IMPROVEMENT_OPPORTUNITY_METRICS,
  ...SESSIONS_METRICS,
];
export const DEFAULT_METRIC = {
  spi: SPI_METRIC,
  opportunities: IMPROVEMENT_OPPORTUNITY_METRICS[0],
  streams: SESSION_WIDGET_CONFIG.bad,
};

export const formatGaugeChartData = (spiScore) => {
  const option = {
    series: [
      {
        type: 'gauge',
        startAngle: 180,
        endAngle: 0,
        radius: '100%',
        center: ['50%', '70%'],
        min: 0,
        max: 100,
        splitNumber: 0,
        axisLine: {
          lineStyle: {
            width: 5,
            color: [
              [0.59, spiColors.low],
              [0.79, spiColors.medium],
              [1, spiColors.high],
            ],
          },
        },
        pointer: {
          icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
          length: '50%',
          width: 3,
          offsetCenter: [0, '-15%'],
          itemStyle: {
            color: 'auto',
          },
        },
        axisTick: {
          length: 1,
          lineStyle: {
            color: 'auto',
            width: 5,
          },
        },
        splitLine: {
          length: 20,
          lineStyle: {
            color: 'auto',
            width: 1,
          },
          show: false,
        },
        axisLabel: {
          fontSize: 20,
          distance: -60,
          formatter() {
            return '';
          },
        },
        title: {
          offsetCenter: [0, '-20%'],
          fontSize: 30,
        },
        detail: {
          fontSize: 50,
          offsetCenter: [40, '5%'],
          valueAnimation: true,
          formatter() {
            return '';
          },
        },
        data: [
          {
            value: spiScore,
          },
        ],
      },
    ],
  };

  return option;
};

export const RED_COLOR = '#c32928';
export const BLUE_COLOR = '#85c3ff';
export const GOOD_SESSIONS_NUMBER_COLOR = '#5197DB';
